module.exports = __webpack_public_path__ + "static/AviaryAttorney3-429adcf683e71c433629f1e9a5231b60.png";